import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { paths } from '../routes';

/**
 * The address exists nowhere — said out loud, because saying nothing looked
 * exactly like the app being broken (#2932).
 *
 * Without a catch-all the signed-in route tree matched nothing on an unknown
 * path, so `#root` stayed empty: a white page, no message, no console output,
 * on a perfectly healthy session. A stale bookmark, a renamed route, a shared
 * link or a typo all produced it, and the reader could not tell "this page does
 * not exist" from "the app is down" from "my session expired".
 *
 * Sibling of `Unauthorized`, deliberately: same shape, same placement, and the
 * same reason for existing — a failure must never look like an absence.
 *
 * It renders INSIDE the layout route, so the sidebar is still there and the
 * reader is one click from anywhere. The link is for the case where it is not:
 * a narrow viewport with the navigation collapsed.
 */
export default function NotFound() {
    const { t } = useTranslation();

    return (
        <div className={'flex m-auto items-center h-[90vh] justify-center px-6'}>
            <div className={'max-w-xl text-center'}>
                <p className={'text-base text-foreground'}>{t('common.page_not_found')}</p>
                <Link
                    to={paths.dashboard}
                    className={'mt-4 inline-block text-base text-foreground underline'}
                >
                    {t('common.back_to_dashboard')}
                </Link>
            </div>
        </div>
    );
}
